	import { Injectable } from '@angular/core';
import { Observable } from "rxjs";
import { BaseService } from "../BaseService";
import { UrlService } from "../UrlService";

@Injectable()
export class DocumentAssignmentService {
	private url: string;

	constructor(
		private myBaseService: BaseService,
		private urlService: UrlService
	){
		this.url = urlService.getURL('DocumentAssignment');
	}
	loadDueDateTrackers(id: System.Guid): Observable<ePM.Logic.DueDateTracker[]> {
		return this.myBaseService.loadAll(this.url + '/' + (id ?? '') + '/DueDateTrackers');
	}
	loadAllForPerson(id: System.Guid): Observable<ePM.Logic.DocumentAssignment[]> {
		return this.myBaseService.loadAll(this.url + '/Person/' + (id || ''));
	}
	loadAllForDocumentHistory(id: System.Guid): Observable<ePM.Logic.DocumentAssignment[]> {
		return this.myBaseService.loadAll(this.url + '/Document/' + (id || ''));
	}
	save(tempItem: ECI.Basic.ObjectBase) : Observable<ePM.Logic.DocumentAssignment> {
		return this.myBaseService.save(tempItem, this.url);
	}
	deleteItem(id: System.Guid): Observable<boolean> {
		return this.myBaseService.deleteItem(id, this.url);
	}
	getEdit(id: System.Guid): Observable<ePM.Logic.DocumentAssignment> {
		return this.myBaseService.getEdit(id, this.url);
	}
	getEditSignature(id: System.Guid): Observable<ePM.Logic.DocumentAssignment> {
		return this.myBaseService.get(id, this.url + '/EditSig');
	}
	get(id: System.Guid) : Observable<ePM.Logic.DocumentAssignment>{
		return this.myBaseService.get(id, this.url);
	}
	sign(tempItem: ECI.Basic.ObjectBase): Observable<ePM.Logic.DocumentAssignment> {
		return this.myBaseService.save(tempItem, this.url + '/Sign');
	}
}
